var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon-M",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M672.9 102.4c-82.7 0-156.5 110.2-204.8 282.6C419.8 212.6 346 102.4 263.3 102.4 117.9 102.4 0 469.2 0 921.6h117C117 501.5 182.5 161 263.3 161c80.8 0 146.3 314.4 146.3 702.1h117c0-387.8 65.5-702.1 146.3-702.1 80.8 0 146.3 340.6 146.3 760.6h117c0-452.4-117.9-819.2-263.3-819.2zM994.8 863.1c-15.9 0-29.3 12.6-29.3 29.1 0 16.8 13.4 29.4 29.3 29.4s29.2-12.6 29.2-29.4c0-16.5-13.3-29.1-29.2-29.1z m0 54.2c-13.6 0-24-10.8-24-25.1 0-14 10.4-24.8 24-24.8 13.4 0 23.9 10.8 23.9 24.8 0 14.3-10.4 25.1-23.9 25.1z",
    fill: "#FFBC0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.5 885c0-6.6-3.8-9.8-11.9-9.8h-13.2v34.2h5.3v-14.7h5.6l9.2 14.7h5.7l-9.7-15.1c5.1-0.5 9-3.1 9-9.3z m-14.2 5.4h-5.5v-10.9h7c3.6 0 7.5 0.7 7.5 5.2-0.1 5.5-4.3 5.7-9 5.7z",
    fill: "#FFBC0D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.77aad6356582caa11f0660809bc5af62.svg";
export { ForwardRef as ReactComponent };